import { PERSISTED_TABS_ID_PREFIX } from '@src/containers/Blotters/HedgePositionStatus/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

export function migrateHedgePositionStatusTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyHedgeTabs = config.tabs?.[PERSISTED_TABS_ID_PREFIX];
  if (legacyHedgeTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyHedgeTabs,
    blotterType: 'hedgePositionStatus',
  });
}
